import type { SceneTimelineKeyPoseFromAPI } from '../types';
import apiRequest from './apiRequest';

export type CreateMotionEditRequest = {
  prompt?: string;
  duration?: number;
  sampler?: string;
  seed?: number | null;
  skeleton?: string;
  constraints?: object[];
  characterEdit?: object;
  autoSwingAnchors?: object;
  callbackURLs?: string[];
};

export type MotionEditorJobStatus =
  | 'QUEUED'
  | 'GENERATING'
  | 'COMPLETED'
  | 'FAILED'
  | 'CANCELLED';

export type MotionEditorJobOperation = 'edit' | 'keyPoseEdit' | (string & {});

export type MotionEditorJobBase = {
  jobID: string;
  status: MotionEditorJobStatus;
  operation: MotionEditorJobOperation;
  createdAt: string;
  updatedAt?: string;
  createdBy?: string;
  completedAt?: string;
  outputBvhURL?: string;
  thumbnailUrl?: string;
  errorMessage?: string;
  prompt?: string;
  userKeyPoseCount?: number;
};

export type MotionEditorJobResponse = MotionEditorJobBase & {
  keyPoses?: SceneTimelineKeyPoseFromAPI[];
};

export type MotionEditorJobListItem = MotionEditorJobBase & {
  /** Present in the motion edit history list response. */
  createdBy: string;
  /** Present in the motion edit history list response. */
  updatedAt: string;
};

export default async function postSceneObjectMotionEdit(
  sceneID: string,
  referenceName: string,
  timelineIndex: number,
  request: CreateMotionEditRequest,
  apiKey: string,
  signal?: AbortSignal,
) {
  return apiRequest<MotionEditorJobResponse>(
    'external-mogen',
    `/scenes/${encodeURIComponent(sceneID)}/objects/${encodeURIComponent(referenceName)}/${timelineIndex}/motionEdits`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': apiKey,
      },
      body: JSON.stringify(request),
    },
    signal,
  );
}
